// src/lib/supabase.js
import { createClient } from '@supabase/supabase-js'

const storage = {
  getItem: (key) => {
    try { return localStorage.getItem(key) } catch { return null }
  },
  setItem: (key, value) => {
    try { localStorage.setItem(key, value) } catch {}
  },
  removeItem: (key) => {
    try { localStorage.removeItem(key) } catch {}
  }
}

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      storage,
      storageKey: 'bellason-auth',
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    }
  }
)